// extracted by mini-css-extract-plugin
module.exports = {"recaptcha":"RecaptchaBadge_recaptcha__JP8eF"};